.container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.6rem;

  & button svg {
    width: 1.8rem;
    height: 1.8rem;
  }
}

.coolDown {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: var(--color-primary-crayola);
  font-family: Inter, sans-serif;
  font-size: 1.4rem;
  font-weight: 400;
  letter-spacing: -0.04rem;
  white-space: nowrap;
}
